export type Role = 'admin' | 'employer' | 'job_seeker';
import { getActingRole } from '@/lib/acting';

export function normalizeRole(r?: string | null): Role | undefined {
  if (!r) return undefined;
  return (r === 'candidate' ? 'job_seeker' : r) as Role;
}

export function getEffectiveRole(
  profile?: { role?: string | null },
  opts?: { allowActing?: boolean }
): Role | undefined {
  const { allowActing = true } = opts || {};
  const dbRole = normalizeRole(profile?.role);
  
  // For admins, allow acting if enabled
  if (dbRole === 'admin' && allowActing) {
    const acting = getActingRole();
    return normalizeRole(acting) ?? dbRole;
  }
  
  // For non-admins or when acting is disabled, return database role
  return dbRole;
}
